<template>
  <div @focusout="handleFocusOut" tabindex="-1" class="position-relative">
    <div class="icon-actions position-relative" ref="iconActions" @click.prevent="toggleShow">
      <div class="action-menu" ref="actionMenu">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseActionMenu',
  data: function() {
    return {
      showMenu: false
    }
  },
  methods: {
    handleFocusOut() {
      if (this.showMenu) this.toggleShow()
    },
    toggleShow(e) {
      this.showMenu = !this.showMenu
      const actionMenu = this.$refs.actionMenu
      if (actionMenu) {
        if (!this.showMenu) {
          actionMenu.style.visibility = 'hidden'
        } else {
          const spaceRight = document.documentElement.clientWidth - e.clientX
          if (spaceRight > actionMenu.offsetWidth) {
            actionMenu.style.right = 'auto'
            actionMenu.style.left = '20px'
          } else {
            actionMenu.style.right = '0px'
            actionMenu.style.left = 'auto'
          }

          const spaceTop = document.documentElement.clientHeight - e.clientY
          if (spaceTop > actionMenu.offsetHeight) {
            actionMenu.style.bottom = 'auto'
            actionMenu.style.top = '20px'
          } else {
            actionMenu.style.bottom = '25px'
            actionMenu.style.top = 'auto'
          }
          actionMenu.style.visibility = 'visible'
        }
      }
    }
  }
}
</script>
